import { URLS } from "@app/shared";

export const careersBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "careersPage.title" },
];

export const nationalityOptions = [
  { label: "nationality.saudi", value: "saudi" },
  { label: "nationality.nonSaudi", value: "nonSaudi" },
];

export const scientificQualificationOptions = [
  { label: "qualification.highSchool", value: "highSchool" },
  { label: "qualification.diploma", value: "diploma" },
  { label: "qualification.bachelorsDegree", value: "bachelorsDegree" },
  { label: "qualification.mastersDegree", value: "mastersDegree" },
  { label: "qualification.doctorate", value: "doctorate" },
  { label: "qualification.other", value: "other" },
];

export const advancedSectionOptions = [
  { label: "department.humanResources", value: "humanResources" },
  { label: "department.finance", value: "finance" },
  { label: "department.accounting", value: "accounting" },
  { label: "department.legalAffairs", value: "legalAffairs" },
  {
    label: "department.corporateCommunications",
    value: "corporateCommunications",
  },
  { label: "department.IT", value: "it" },
  { label: "department.investorRelations", value: "investorRelations" },
  { label: "department.internalAudit", value: "internalAudit" },
  { label: "department.riskAndCompliance", value: "riskAndCompliance" },
  {
    label: "department.strategyAndBusinessDevelopment",
    value: "strategyAndBusinessDevelopment",
  },
  { label: "department.salesAndMarketing", value: "salesAndMarketing" },
  { label: "department.procurement", value: "procurement" },
  { label: "department.quality", value: "quality" },
  { label: "department.healthAndSafety", value: "healthAndSafety" },
  { label: "department.maintenance", value: "maintenance" },
  { label: "department.production", value: "production" },
  { label: "department.engineering", value: "engineering" },
  { label: "department.technicalServices", value: "technicalServices" },
  { label: "department.planning", value: "planning" },
  { label: "department.supplyChain", value: "supplyChain" },
  { label: "department.administration", value: "administration" },
  { label: "department.other", value: "other" },
];

export const programOrCareerPathOptions = [
  { label: "careerPaths.Co-opProgram", value: "Co-opProgram" },
  { label: "careerPaths.tamheerProgram", value: "tamheerProgram" },
  { label: "careerPaths.freshGraduates", value: "freshGraduates" },
  {
    label: "careerPaths.experiencedProfessionals",
    value: "experiencedProfessionals",
  },
];
